import { render, staticRenderFns } from "./InformationManagementView.vue?vue&type=template&id=1cef875e"
import script from "./InformationManagementView.vue?vue&type=script&lang=js"
export * from "./InformationManagementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports